import { type ReactNode, useCallback, useMemo } from 'react';
import { type CreateExportJobVariables, ExportContext, type ExportHooks } from '@/contexts/ExportContext';
import { createExportJobMutation } from '@/lib/api/export';
import { useApiConfig } from '@/providers/ApiConfigProvider';
import type { CreateExportJobMutationResult, Forms } from '@/types/export';

interface ExportProviderProps {
  children: ReactNode;
}

export function ExportProvider({ children }: ExportProviderProps) {
  const apiConfig = useApiConfig();

  const handleCreateExportJob = useCallback(
    async (variables: CreateExportJobVariables<Forms>): Promise<CreateExportJobMutationResult> => {
      return createExportJobMutation(apiConfig, variables.export);
    },
    [apiConfig],
  );

  const value = useMemo<ExportHooks<Forms>>(
    () => ({ createExportJob: handleCreateExportJob }),
    [handleCreateExportJob],
  );

  return <ExportContext.Provider value={value}>{children}</ExportContext.Provider>;
}
